import { render, staticRenderFns } from "./Apporteur.vue?vue&type=template&id=93852588&scoped=true&"
import script from "./Apporteur.vue?vue&type=script&lang=js&"
export * from "./Apporteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93852588",
  null
  
)

export default component.exports